// import { Component, EventEmitter, Input, Output } from '@angular/core';
// import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { ToastrService } from 'ngx-toastr';
// import { ApiServiceService } from 'src/app/services/api-service.service';

// @Component({
//   selector: 'app-ask-question',
//   templateUrl: './ask-question.component.html',
// })
// export class AskQuestionComponent {
//   @Input() productId!: any;
//   @Output() closeModal = new EventEmitter<void>();

//   questionForm: FormGroup;

//   constructor(private fb: FormBuilder, private api: ApiServiceService , private toaster:ToastrService) {
//     this.questionForm = this.fb.group({
//       question: ['', Validators.required],
//     });

    
//   }


//   ngOnInit(){
//     console.log('productId' ,this.productId)


//      if (localStorage.getItem('token')) {
//     this.api.getUserByToken().subscribe({
//       next: (user) => {
//         localStorage.setItem('user', JSON.stringify(user));
//       },
//       error: () => {
//         localStorage.clear();
//       }
//     });
//   }
//   }

//   close() {
//     this.closeModal.emit();
//   }

 
  

  
//   submit() {
//     if (this.questionForm.invalid) return;

//     const payload = {
//       productId: this.productId,
//       ...this.questionForm.value,
//     };

//     this.api.askQuestion(payload).subscribe({
//       next: () => {
//         this.toaster.success('Question submitted successfully!');
//         this.close();
//       },
//       error: () => {
//          this.toaster.error('Something went wrong');
//       }
//     });
//   }
// }


import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { ApiServiceService } from 'src/app/services/api-service.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-ask-question',
  templateUrl: './ask-question.component.html',
})
export class AskQuestionComponent implements OnInit {
  @Input() productId!: string; // ✅ pass ONLY productId
  @Output() closeModal = new EventEmitter<void>();

  questionForm!: FormGroup;
  user: any;

  constructor(
    private fb: FormBuilder,
    private api: ApiServiceService,
    private toaster: ToastrService,
  ) {}

ngOnInit(): void {
  if (localStorage.getItem('token')) {
    this.api.getUserByToken().subscribe({
      next: (res) => {
        this.user = res.data; // ✅ FIX HERE
        localStorage.setItem('user', JSON.stringify(res.data));
      },
      error: () => {
        localStorage.clear();
      }
    });
  }

  this.questionForm = this.fb.group({
    question: ['', Validators.required],
  });
}



  close() {
    this.closeModal.emit();
  }

submit() {
  if (this.questionForm.invalid) return;

  const payload = {
    productId: this.productId,
    name: this.user.name,
    email: this.user.email,
    question: this.questionForm.value.question,
  };

  this.api.askQuestion(payload).subscribe({
    next: () => {
      this.toaster.success('Question submitted successfully!');
      this.close();
    },
    error: () => {
      this.toaster.error('Something went wrong');
    },
  });
}


}
